const SC_FIL_DATE_KEY = 'SCfilDate';

/**
 * Saves a Date to localStorage as ISO string.
 * Ignores null, undefined, or Invalid Date values.
 */
export const saveSCfilDate = (date: Date): void => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return;
    localStorage.setItem(SC_FIL_DATE_KEY, date.toISOString());
};

/**
 * Loads and parses SCfilDate from localStorage.
 * Returns null if missing or invalid.
 */
export const loadSCfilDate = (): Date | null => {
    const stored = localStorage.getItem(SC_FIL_DATE_KEY);
    if (!stored) return null;
    const parsed = new Date(stored);
    return isNaN(parsed.getTime()) ? null : parsed;
};

/**
 * Removes SCfilDate from localStorage.
 */
export const clearSCfilDate = (): void => {
    localStorage.removeItem(SC_FIL_DATE_KEY);
};